// extracted by mini-css-extract-plugin
export default {"container":"zjJOQ2JHPCEtLv83T4QL","item":"SIbURtAVMDP0irQDsH0Z","Ellipsis":"VJ1YmnFmIAezOPrFl1T_"};